<template>
  <header :class="['header', 'panel', _isMobile() ? 'mobile' : '']">
    <div class="logo-bar">
      <a-row type="flex" justify="space-between" class="menu-up">
        <a-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
          <div class="logo">
              <img :src="logo ? logo : '/img/logo.png'" alt=""/>
          </div>
        </a-col>
        <a-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
          <div class="login-btn-wrap">
            <div class="header-avatar">
              <!-- <a-avatar @click="toCenter" icon="user" :src="avatarUrl" /> -->
              <img class="avatar" :src="avatarUrl" @click="toCenter" alt="">
              <span v-if="$store.state.user.info">
                <span @click="toCenter">{{ $store.state.user.info.realname }}</span>
                <a-divider type="vertical" />
                <span @click="handleLogout">退出</span>
              </span>
              <span v-else>
                <span @click="toLogin">登录</span>
                <a-divider type="vertical" />
                <span @click="toRegister">注册</span>
              </span>
            </div>
            
          </div>
        </a-col>
      </a-row>
    </div>
    <div
      :class="['menu-bar', showMenu ? 'show' : 'hide', menuFixed?'menu-fixed':'']"
      @mouseleave="leave"
      @mouseover="over"
    >
      <t-menu class="menu" mode="horizontal" :menu="menus"></t-menu>
    </div>
  </header>
</template>
<script>
import Vue from "vue";
import { TENANT_CONFIG, ACCESS_TOKEN } from "@/store/mutation-types";
import config from "../theme.config";
import { mapActions } from "vuex";
import { mixinDevice } from "@/utils/mixin.js";
import TMenu from "@/components/menu"
import { jumpMixins } from "@/utils/jumpMixins"
import { getQiniuUrl,getQiniuFile } from '@/utils/qiniu.js'

export default {
  name: "Header",
  mixins: [mixinDevice, jumpMixins],
  props: {
    autoHide: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    TMenu
  },
  data() {
    return {
      showLogin: false,
      showRegister: false,
      showMenu: true,
      logo: "",
      token: "",
      cycssToken: "",
      menus: [],
      menuFixed: false
    };
  },
  created() {
    this.token = Vue.ls.get(ACCESS_TOKEN);
    this.cycssToken = Vue.ls.get("cysccToken")
    let tenantInfo = this.$store.getters.tenantInfo
    this.logo = tenantInfo.logo
    this.menus = this.$store.getters.menuList
  },
  computed:{
    avatarUrl(){
      if(this.$store.state.user.info && this.$store.state.user.info.avatar){
        if(this.$store.state.user.info.thirdType == "cyscc"){
          return "https://cast-files.oss-cn-beijing.aliyuncs.com/" + this.$store.state.user.info.avatar
        }else{
          return this.getQiniuUrl(this.$store.state.user.info.avatar)
        }
      }else{
        return require("../assets/avatar2.png")
      }
    }
  },
  mounted() {
    window.addEventListener('scroll', this.handleScroll)
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.handleScroll)
  },
  methods: {
    getQiniuUrl,
    getQiniuFile,
    ...mapActions(["Logout"]),
    onSearch(v) {
      console.log(v);
    },
    leave() {
      if (this.autoHide) this.showMenu = false;
    },
    over() {
      if (this.autoHide) this.showMenu = true;
    },
    handleScroll(){
      let scrollTop = document.documentElement.scrollTop
      if (scrollTop >= 105) {
        this.menuFixed = true
      } else {
        this.menuFixed = false
      }
    },
    loginSuccess() {
      this.showLogin = false;
      this.userInfo = this.$store.state.user.info;
    },
    regSuccess() {
      this.showRegister = false;
      this.showLogin = true;
    },
    handleLogout() {
      const that = this;
      this.$confirm({
        title: "提示",
        content: "真的要注销登录吗 ?",
        onOk() {
          return that
            .Logout({})
            .then(() => {
              Vue.ls.remove("cysccToken")
              window.location.reload()
            })
            .catch((err) => {
              that.$message.error({
                title: "错误",
                description: err.message,
              });
            });
        },
        onCancel() {},
      });
    },
  },
};
</script>
<style lang="less" scoped>
.hide {
  height: 50px;
  background-color: transparent !important;
  transition: all 0.1s ease;
}

.logo-bar {
  z-index: 99;
  // background: #fff;
  // border-bottom: 1px solid #f5f7fa;
  .menu-up {
    max-width: 1200px;
    margin: auto;
    padding: 10px 0;
    // height: 80px;
    .logo {
      margin-top: 5px;
      img {
        display: inline-block;
        height: 50px;
      }
      h2 {
        display: inline;
        font-style: italic;
        font-size: 20px;
        color: #ffffff;
        line-height: 30px;
        text-shadow: #b3b0b0ab 5px 3px 5px;
      }
    }
    .login-btn-wrap {
      .header-avatar{
        padding: 5px 20px;
        min-width: 155px;
        height: 45px;
        float: right;
        background: url(~@assets/theme/aipj/header-login-bg.png) no-repeat;
        background-size: 100% 100%;
        cursor: pointer;
        .ant-avatar {
          margin-right: 5px;
        }
        .avatar{
          margin-right: 5px;
          margin-bottom: 5px;
          max-height: 30px;
        }
        span {
          color: #fff;
          font-weight: 700;
        }
      }
      text-align: right;
      margin-top: 25px;
      // margin-right: 50px;
      /deep/.ant-input{
        background-color: transparent;
        color: white;
      }
      /deep/.ant-input-suffix{
        i{
          color: rgba(255, 255, 255, 0.82);
        }
      }
      .help {
        color: gray;
      }
    }
  }
}
.menu-fixed{
    position: fixed;
    top: 0px;
    z-index: 99;
    padding-bottom: 10px;
    background: radial-gradient(ellipse at top left, rgba(250,194,44,0.5) 10%, rgba(255,101,73, 0.5) 67%)
}
.menu-bar {
  width: 100%;
  z-index: 999;
  .menu {
    background: transparent;
    max-width: 1200px;
    margin: auto;
    /deep/.ant-menu-item,/deep/.ant-menu-submenu{
      // background: rgb(37,106,243);
      // border-radius: 10px;
      border-bottom: none;
      line-height: 35px;
      padding: 0 8px;
      
      .ant-menu-submenu-title{
        padding: 0 8px;
      }
      a{
        display: block;
        transition: 300ms;
        // background-image: url(../assets/menu-item.png);
        // background-repeat: no-repeat;
        // background-size: 100% 100%;
        background-color: white;
        border-radius: 5px;
        box-shadow: 0 0 5px 0 rgba(0,0,0,0.1);
        padding: 2px 20px;

        font-family: "微软雅黑 Bold", "微软雅黑 Regular", "微软雅黑", sans-serif;
        font-size: 16px;
        color: black;
      }
    }

    /deep/.ant-menu-submenu-active,
    /deep/.ant-menu-item-active {
      // background: linear-gradient(85deg, rgb(5,65,248), rgb(56,217,251));
      
      border-bottom: none;
      font-weight: 700;
      a{
        // background-image: url(../assets/menu-item-hover.png);
         background: linear-gradient(85deg, rgb(250,194,44), rgb(255,101,73));
         color: white;
      }
    }
  }
  .ant-menu-horizontal {
    border-bottom:none;
  }
}

.mobile {
  .logo {
    margin-top: 5px;
    margin-left: 15px;
  }
  .login-btn-wrap {
    margin-right: 20px !important;
  }
  .ant-menu-item {
    padding: 0 8px;
  }
  .ant-menu-item > a {
    font-size: 12px !important;
  }
  .menu {
    padding: 0px 15px;
  }
}
</style>